import styled from 'styled-components';

export const Wrapper = styled.div<{ $backgroundColor: string; $borderColor: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ $backgroundColor }) => $backgroundColor};
  border: 1px solid ${({ $borderColor }) => $borderColor};
  border-radius: 4px;
  padding: 4px 8px;
`;

export const Text = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
